import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ReactTable from "react-table";
import moment from "moment";
import {Button} from "reactstrap";
import {Link} from "react-router-dom";
import Edit from '@material-ui/icons/Edit'
import CheckBox from '@material-ui/icons/CheckBox'

export default class ManagersApproval extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets_Financials._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request='GET_UNAPPROVED';
	}

	formatDate(val){
		return moment(val).local().format('MM/DD/YYYY h:mm A')

	}

	render(){
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Ticket #",
				id: 'ticket',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.ticket,
				Cell: (props) => {


					if (!props.original.ticket) return null;

					return (
						<span>
							<Link to={`/tickets/${props.original.ticket}`}>
								{props.original.ticket}
							</Link>
						</span>
					);
				}
			},

			{
				Header: "Date",
				id: 'date_created',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.created ? moment(obj.created).local().format('MM/DD/YYYY h:mm A') : '',
			},
			{
				Header: "Field Engineer",
				id: 'customer',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.customers ? obj.customers.name : '',
				Cell: (props) => {
					console.log(props)
					if (!props.original.tickets.customers) return null;

					return (
						<span>
							<Link to={`/customers/${props.original.tickets.pkey}`}>
								{props.original.tickets.customers.name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Customer",
				id: 'customer',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.customers ? obj.customers.name : '',
				Cell: (props) => {
					console.log(props)
					if (!props.original.tickets.customers) return null;

					return (
						<span>
							<Link to={`/customers/${props.original.tickets.pkey}`}>
								{props.original.tickets.customers.name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Payment Type",
				id: 'financial_type',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.tickets_financials_types.name,
			},
			{
				Header: "Expected Labor Amount",
				id: 'expected_labor_amount',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.expected_labor,
			},
			{
				Header: "Labor Difference",
				id: 'labor_difference',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.expected_labor !==obj.labor_amount ? "$"+(obj.expected_labor -obj.labor_amount).toFixed(2): "0.00",
			},

			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							{props.original.approved === false ?
								<Button id={props.original.pkey} ticket={props.original.ticket} color="secondary" size={"sm"} block={true} onClick={this.approve}>
									<i className={"fa fa-exclamation"}/></Button>
								:	<Link to={"/financial/" + props.original.pkey}> <Button color="primary" size={"sm"} block={true}> <CheckBox fontSize={'small'}/></Button></Link>
							}
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={"/financial/" + props.original.ticket}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},

		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Approvals')}
							{this.renderHeaderRight("Managers_Approval",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		);
	}
}